import React from "react";

export default function MedalsIcon({
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  onClick,
  className,
  style = {},
  ...rest
}) {
  const mergedStyle = Object.assign(
    { width: size, height: size, cursor: onClick ? "pointer" : undefined },
    style
  );
  const svgProps = {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: size,
    height: size,
    fill: "none",
    stroke: color,
    strokeWidth,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    onClick,
    className,
    style: mergedStyle,
    ...rest
  };
  return React.createElement(
    "svg",
    svgProps,
    React.createElement("path", { d: "M7.21 15 2.66 7.14a2 2 0 0 1 .13-2.2L4.4 2.8A2 2 0 0 1 6 2h12a2 2 0 0 1 1.6.8l1.6 2.14a2 2 0 0 1 .14 2.2L16.79 15" }),
    React.createElement("path", { d: "M11 12 5.12 2.2" }),
    React.createElement("path", { d: "m13 12 5.88-9.8" }),
    React.createElement("path", { d: "M8 7h8" }),
    React.createElement("circle", { cx: 12, cy: 17, r: 5 }),
    React.createElement("path", { d: "M12 18v-2h-.5" })
  );
}